const CollapsibleContainerNames = [
  "dietaryInfo",
  "endorsement",
  "faqs",
  "generalInfo",
  "guides",
  "highlights",
  "inclusions",
  "influencerRecommendation",
  "itinerary",
  "meetingPlace",
  "omissions",
  "recentPhotos",
  "reviews",
  "summary",
  "youtube",
] as const;

export type CollapsibleContainerName =
  (typeof CollapsibleContainerNames)[number];

const defaultOrder: readonly CollapsibleContainerName[] = [
  "summary",
  "influencerRecommendation",
  "endorsement",
  "inclusions",
  "omissions",
  "guides",
  "highlights",
  "recentPhotos",
  "meetingPlace",
  "generalInfo",
  "dietaryInfo",
  "faqs",
  "reviews",
  "youtube",
];

export const collapsibleContainerConfigs: Record<
  string,
  {
    collapsed: readonly CollapsibleContainerName[];
    order: readonly CollapsibleContainerName[];
    separateItinerary: boolean;
    renameYoutubeTitle: boolean;
  }
> = {
  none: {
    separateItinerary: false,
    renameYoutubeTitle: false,
    collapsed: [],
    order: defaultOrder,
  },
  minimal: {
    separateItinerary: false,
    renameYoutubeTitle: false,
    collapsed: [
      "dietaryInfo",
      "endorsement",
      "faqs",
      "generalInfo",
      "guides",
      "highlights",
      // "inclusions",
      "meetingPlace",
      "recentPhotos",
      "reviews",
      // "summary",
      "youtube",
    ],
    order: [
      "summary",
      "inclusions",
      "guides",
      "endorsement",
      "omissions",
      "highlights",
      "recentPhotos",
      "meetingPlace",
      "generalInfo",
      "dietaryInfo",
      "faqs",
      "reviews",
      "youtube",
    ],
  },
  balanced: {
    separateItinerary: true,
    renameYoutubeTitle: true,
    collapsed: [
      "dietaryInfo",
      // "endorsement",
      "faqs",
      "generalInfo",
      // "guides",
      // "highlights",
      // "inclusions",
      "itinerary",
      "meetingPlace",
      // "recentPhotos",
      // "reviews",
      // "summary",
      "youtube",
    ],
    order: [
      "summary",
      "inclusions",
      "guides",
      "endorsement",
      "omissions",
      "highlights",
      "recentPhotos",
      "reviews",
      "meetingPlace",
      "itinerary",
      "generalInfo",
      "dietaryInfo",
      "faqs",
      "youtube",
    ],
  },
} as const;
